module.exports = __webpack_public_path__ + "img/bannerProvUbicacion.89d67061.jpg";